import { request } from '@/common/utils/request'

export function getNormalAreaTree(params) {

  return request
    .get({
      url: 'feidian.bdapp.bizopp.getAreaTree',
      params
    })
    .then(res => res.data)
}

export function getBDAreaTree(params) {
  return request
    .get({
      url: 'feidian.area.bdapp.getAreaTree',
      params
    })
    .then(res => res.data)
}

export function getCityByPoi(params) {
  return request
    .get({
      url: 'feidian.bdapp.common.getCityByPoi',
      params
    })
    .then(res => res.data)
}
